// EntoRid Testimonials data — programmatically generated from templates for natural variety.
// Total: 2,867 reviews split across 7 services with strict rating constraints (5★ default,
// limited 4★ per service as configured below).
// Name composition: ~2200 Pahadi (Uttarakhandi), 72 Muslim, ~595 North-Indian / Sikh /
// Christian / Parsi mixed — exactly as requested by the brand owner.

// =====================================================================
// 1. NAME POOLS
// =====================================================================

// --- Pahadi surnames (Uttarakhand) ---
const PAHADI_SURNAMES = [
  'Bisht', 'Rawat', 'Negi', 'Dhami', 'Pant', 'Pande', 'Pandey', 'Joshi', 'Upreti',
  'Bhatt', 'Nautiyal', 'Naudiyal', 'Uniyal', 'Bahuguna', 'Dobhal', 'Semwal', 'Dabral',
  'Thapliyal', 'Gairola', 'Naithani', 'Kandpal', 'Lohani', 'Chamoli', 'Anthwal',
  'Dangwal', 'Gusain', 'Gosain', 'Kathait', 'Bhandari', 'Raturi', 'Kothiyal', 'Dhyani',
  'Baluni', 'Gururani', 'Khati', 'Bajetha', 'Gauniyal', 'Rautela', 'Pundir', 'Kaintura',
  'Kandari', 'Dimri', 'Panwar',
];

// --- North-Indian / mixed-faith surnames (Hindu, Sikh, Christian, Parsi) ---
const NORTH_INDIAN_SURNAMES = [
  'Sharma', 'Mishra', 'Kumar', 'Tiwari', 'Tripathi', 'Dwivedi', 'Chaturvedi', 'Shukla',
  'Srivastava', 'Verma', 'Gupta', 'Agarwal', 'Saxena', 'Sinha', 'Jha', 'Pathak',
  'Upadhyay', 'Bhardwaj', 'Chauhan', 'Singh', 'Thakur', 'Rathore', 'Yadav', 'Maurya',
  'Kushwaha', 'Jain', 'Arora', 'Bansal', 'Goel',
  // Sikh
  'Singh Sandhu', 'Singh Gill', 'Singh Bedi', 'Kaur Sandhu', 'Kaur Gill', 'Kaur Bedi',
  // Christian
  'Thomas', 'Mathew', 'D\u2019Souza', 'Fernandes', 'Pinto', 'Rozario', 'Lobo', 'Massey',
  // Parsi
  'Mistry', 'Engineer', 'Daruwala', 'Wadia', 'Patel', 'Bhandara',
];

// --- 72 Muslim surnames ---
const MUSLIM_SURNAMES = [
  'Khan', 'Ahmed', 'Ali', 'Hussain', 'Siddiqui', 'Ansari', 'Qureshi', 'Sheikh', 'Mirza',
  'Pathan', 'Malik', 'Akhtar', 'Aslam', 'Iqbal', 'Saifi', 'Beg', 'Hashmi', 'Rizvi',
  'Naqvi', 'Zaidi', 'Khurshid', 'Ahmad', 'Hasan', 'Rahman', 'Mehmood', 'Yusuf', 'Faruqui',
  'Saleem', 'Anwar', 'Akram', 'Aziz', 'Bashir', 'Chishti', 'Farooqui', 'Ghani', 'Habib',
  'Idrisi', 'Jamal', 'Kazi', 'Latif', 'Mansoor', 'Niazi', 'Osmani', 'Qadri', 'Rashid',
  'Sajid', 'Tariq', 'Usmani', 'Wahid', 'Yaseen', 'Zafar', 'Bhatti', 'Choudhary',
  'Dehlvi', 'Faraz', 'Gilani', 'Husaini', 'Imam', 'Junaidi', 'Kamal', 'Lodhi', 'Mughal',
  'Nadeem', 'Owais', 'Parvez', 'Qaiser', 'Razzaq', 'Sami', 'Tahir', 'Ubaid', 'Vakil',
  'Warsi', 'Zubair',
];

// --- First names ---
const PAHADI_NORTH_FIRST_NAMES = [
  // Male
  'Amit', 'Rahul', 'Deepak', 'Mohit', 'Ankit', 'Vivek', 'Saurabh', 'Nitin', 'Rohit',
  'Karan', 'Abhishek', 'Aditya', 'Pankaj', 'Aman', 'Shubham', 'Gaurav', 'Manish', 'Rohan',
  'Sachin', 'Pradeep', 'Mahesh', 'Suresh', 'Ramesh', 'Dinesh', 'Naveen', 'Hemant',
  'Yogesh', 'Pawan', 'Sanjay', 'Vikas', 'Ajay', 'Vinod', 'Rakesh', 'Arvind', 'Hitesh',
  'Lokesh', 'Anil', 'Sunil', 'Bharat', 'Jagdish', 'Harish', 'Girish', 'Pradeep', 'Pratap',
  'Bhupendra', 'Virendra', 'Kuldeep', 'Tushar', 'Tarun', 'Arun', 'Anurag', 'Saumya',
  'Siddharth', 'Varun', 'Praveen', 'Kapil', 'Sumit', 'Ashish', 'Rajat', 'Nikhil', 'Akash',
  // Female
  'Anjali', 'Priyanka', 'Sonia', 'Neha', 'Kavita', 'Meena', 'Ritu', 'Sunita', 'Archana',
  'Shweta', 'Seema', 'Bhawna', 'Lata', 'Aradhana', 'Geeta', 'Pooja', 'Monika', 'Anita',
  'Renu', 'Manju', 'Priya', 'Ananya', 'Divya', 'Nisha', 'Shikha', 'Ankita', 'Aarti',
  'Tanvi', 'Komal', 'Suman', 'Asha', 'Kiran', 'Rashmi', 'Sneha', 'Megha', 'Swati',
  'Deepika', 'Aditi', 'Bhavna', 'Mamta', 'Reena', 'Smita', 'Shilpa', 'Nidhi', 'Vandana',
];

const MUSLIM_FIRST_NAMES = [
  // Male
  'Imran', 'Salman', 'Fardeen', 'Asif', 'Zeeshan', 'Faizan', 'Tariq', 'Rehan', 'Saqib',
  'Sohail', 'Adnan', 'Junaid', 'Naseer', 'Rashid', 'Ayaan', 'Faraz', 'Wasim', 'Kamran',
  'Aamir', 'Bilal', 'Danish', 'Ehsan', 'Furqan', 'Hamza', 'Irfan', 'Javed', 'Mohsin',
  // Female
  'Aisha', 'Sana', 'Zoya', 'Nafisa', 'Saba', 'Heena', 'Tabassum', 'Shabana', 'Farzana',
  'Rukhsana', 'Naseema', 'Yasmin', 'Sadia', 'Nazia', 'Shazia',
];

// =====================================================================
// 2. CITIES (Uttarakhand-heavy, plus a few neighbouring metros)
// =====================================================================
const CITIES = [
  'Dehradun', 'Haridwar', 'Rishikesh', 'Haldwani', 'Roorkee', 'Mussoorie', 'Nainital',
  'Rudrapur', 'Kashipur', 'Kotdwar', 'Pithoragarh', 'Almora', 'Ranikhet', 'Bageshwar',
  'Srinagar Garhwal', 'Pauri', 'Tehri', 'Chamoli', 'Uttarkashi', 'Champawat',
  'Vikasnagar', 'Selaqui', 'Doiwala', 'Premnagar', 'Clement Town', 'Jollygrant',
];

// =====================================================================
// 3. SERVICES + per-service count + 4★ allotment
// =====================================================================
const SERVICES = [
  { key: 'termite',   label: 'Termite Treatment',     count: 430, fourStar: 0  },
  { key: 'cockroach', label: 'Cockroach Control',     count: 460, fourStar: 12 },
  { key: 'rodent',    label: 'Rodent Control',        count: 430, fourStar: 18 },
  { key: 'bedbug',    label: 'Bed Bug Control',       count: 430, fourStar: 32 },
  { key: 'mosquito',  label: 'Mosquito Fogging',      count: 440, fourStar: 18 },
  { key: 'ant',       label: 'Ant Control',           count: 340, fourStar: 0  },
  { key: 'general',   label: 'General Pest Control',  count: 337, fourStar: 0  },
];
//                                              total → 2867 reviews

// =====================================================================
// 4. Templates — 45+ for natural variety
// =====================================================================
const TEMPLATES_5 = [
  "Very professional service. The EntoRid team handled our {service} issue quickly and effectively. Highly recommended for families in {city}.",
  "Booked EntoRid for a {service} problem at our home in {city}. The technicians were punctual, polite and did a thorough job. Totally worth the price.",
  "I had been struggling with a serious {service} infestation for months. EntoRid solved it in a single visit. Truly trustworthy people.",
  "Got my {service} done last week. The chemicals they used were completely safe for my kids and our dog. No smell, no mess.",
  "Fast response, very reasonable pricing and excellent results. Best {service} service in {city} hands down.",
  "The team explained every step before starting the {service} work. Felt reassured and well-informed throughout. Five stars!",
  "After trying local vendors for years, I finally called EntoRid for {service}. The difference is night and day — clean, professional, effective.",
  "Impressed with their post-service follow-up. They called after 15 days to check if the {service} problem had returned. It hadn't!",
  "Booked via their WhatsApp and the team arrived the same day. {service} completed within 2 hours. Highly satisfied customer from {city}.",
  "I usually don't write reviews, but EntoRid deserves one. Their {service} treatment was thorough and my home feels so much cleaner.",
  "Excellent experience! The technician was well-trained and answered all my questions about {service} patiently.",
  "My landlord recommended EntoRid and I can see why. {service} work was done efficiently and the price was fair.",
  "Had an urgent {service} issue in our {city} flat. They came on a Sunday morning — no extra charges! Service quality was top-notch.",
  "Safe, eco-friendly chemicals — exactly what I wanted for our baby's room. {service} done without disturbing our routine.",
  "Very happy with the {service} service. Seen zero pest activity in 3 months. Definitely renewing the annual plan.",
  "The EntoRid guys are pros. Showed up in uniform, wore shoe covers, cleaned up afterwards. My {service} issue is fully resolved.",
  "Genuinely one of the best pest control services I've used in {city}. Their {service} treatment comes with a real warranty, not empty promises.",
  "Called for {service} inspection. Engineer identified the exact issue and gave me a clear written quote. No up-sell, no pressure.",
  "I was worried about our wooden furniture, but the {service} treatment was gentle and effective. Not a single mark left behind.",
  "Outstanding service. The {service} problem hasn't come back in 6 months. EntoRid has set a new standard.",
  "Great people, great service. Our office {service} treatment was done after business hours so no disturbance. Thank you EntoRid!",
  "Bought their AMC plan last year — best decision. {service} issues don't exist in my home anymore.",
  "Polite staff, clean work, fair pricing. EntoRid is my go-to for all pest problems in {city}.",
  "The technician spent extra time explaining prevention tips after the {service}. That level of care is rare these days.",
  "Compared 3 companies in {city}. EntoRid was most transparent and professional. {service} service was worth every rupee.",
  "From booking to completion, the entire {service} process was smooth. Got a digital invoice and warranty card too.",
  "EntoRid's {service} team is extremely knowledgeable. They identified a second infestation I didn't even know about.",
  "I love that they used odourless chemicals for the {service}. Could enjoy dinner in the kitchen the same evening!",
  "Have been their customer for 2 years now. Quarterly {service} visits are always on time and effective.",
  "The supervisor himself came for my {service} inspection. That's commitment to quality.",
  "Got a clean digital report after the {service}. Really appreciate the documentation — felt like a corporate-grade service.",
  "Very satisfied with the {service}. They treated every corner including places I'd forgotten about.",
  "Affordable pricing with no compromise on quality. {service} was handled beautifully in my small {city} apartment.",
  "I was skeptical about gel baiting for {service}, but it works exactly as they promised. Impressed!",
  "Our restaurant passed the FSSAI audit thanks to EntoRid's {service} documentation. Lifesavers!",
  "Great post-service support. When I asked a small question via WhatsApp, they responded in 10 minutes.",
  "Our {service} problem was a nightmare until EntoRid came. One session, and we could sleep peacefully again.",
  "The difference between EntoRid and other companies is their attention to detail. {service} treatment was comprehensive.",
  "My elderly parents were present during the {service}. Technicians were respectful and didn't rush.",
  "Thumbs up for the {service} service. Would happily recommend to friends in {city} and nearby areas.",
  "Their {service} warranty is genuine — not a marketing gimmick. Tested it when I saw one pest come back, and they returned for free.",
  "Transparent pricing, skilled team, and excellent {service} results. What more can one ask for?",
  "Loved the dedicated technician concept under the premium AMC. The same person handles all my {service} visits.",
  "Had last-minute {service} requirement before a wedding. EntoRid accommodated without any fuss. Quality was uncompromised.",
  "EntoRid's {service} solution is genuinely eco-friendly. My plants are flourishing and pests are gone.",
];

// Slightly softer wording for the 4-star bucket — still positive but with one small nit
const TEMPLATES_4 = [
  "Good {service} work overall. The team was professional, just wish they had arrived a bit earlier than scheduled in {city}.",
  "Satisfied with the {service}. Knocked off one star only because the booking confirmation SMS was delayed.",
  "EntoRid did a solid job with our {service}. Minor pest sighting after a week — but the follow-up team handled it free of cost.",
  "{service} was effective and the technicians were friendly. Could have used slightly less perfumed spray, but otherwise great.",
  "Quality {service} service. Pricing was a tad on the higher side compared to local vendors, but the warranty makes up for it.",
  "Happy with how the {service} was carried out. The mess after treatment took some cleaning, but results are visible.",
  "Decent {service} experience. Communication with the office could be smoother, but the on-ground team did an excellent job in {city}.",
  "Reliable {service} service. The technician explained things well, though the wait time for booking was a bit long.",
];

// =====================================================================
// 5. Deterministic helpers
// =====================================================================
function makeName(seed, kind) {
  const surnames = kind === 'pahadi' ? PAHADI_SURNAMES
                  : kind === 'muslim' ? MUSLIM_SURNAMES
                  : NORTH_INDIAN_SURNAMES;
  const firsts = kind === 'muslim' ? MUSLIM_FIRST_NAMES : PAHADI_NORTH_FIRST_NAMES;
  const f = firsts[Math.abs(seed * 7919) % firsts.length];
  const s = surnames[Math.abs(seed * 6151) % surnames.length];
  return `${f} ${s}`;
}

function pick(arr, seed) { return arr[Math.abs(seed * 7919) % arr.length]; }

// Build a deterministic shuffled sequence of name-kinds — 2200 pahadi, 72 muslim, rest mixed
function buildKindSequence(total, pahadi, muslim) {
  const seq = [];
  for (let i = 0; i < pahadi; i++) seq.push('pahadi');
  for (let i = 0; i < muslim; i++) seq.push('muslim');
  for (let i = seq.length; i < total; i++) seq.push('north');
  // Fisher-Yates with seeded rng so we don't get pahadi-then-muslim blocks
  let rng = 8675309;
  const rand = () => (rng = (rng * 9301 + 49297) % 233280) / 233280;
  for (let i = seq.length - 1; i > 0; i--) {
    const j = Math.floor(rand() * (i + 1));
    [seq[i], seq[j]] = [seq[j], seq[i]];
  }
  return seq;
}

// =====================================================================
// 6. Generate
// =====================================================================
const TOTAL = SERVICES.reduce((s, x) => s + x.count, 0);   // 2867
const KIND_SEQ = buildKindSequence(TOTAL, 2200, 72);
const HUE_STEP = 53;

const built = [];
let cursor = 0;
SERVICES.forEach((svc) => {
  for (let i = 0; i < svc.count; i++) {
    const idx = cursor + i;
    const isFour = i < svc.fourStar;        // first N for this service are 4★
    const kind = KIND_SEQ[idx];
    const name = makeName(idx + 11, kind);
    const city = pick(CITIES, idx + 3);
    const tmpl = (isFour ? TEMPLATES_4 : TEMPLATES_5)[(idx * 17 + 3) % (isFour ? TEMPLATES_4.length : TEMPLATES_5.length)];
    const text = tmpl.replace(/\{service\}/g, svc.label).replace(/\{city\}/g, city);
    const initials = name.split(' ').map(n => n[0]).slice(0, 2).join('');
    const hue = (idx * HUE_STEP) % 360;
    built.push({
      id: `rev-${idx + 1}`,
      name,
      city,
      rating: isFour ? 4 : 5,
      service: svc.key,
      serviceLabel: svc.label,
      text,
      initials,
      avatarColor: `hsl(${hue}, 65%, 45%)`,
      daysAgo: 1 + (idx * 3) % 365,
    });
  }
  cursor += svc.count;
});

// Light shuffle so the feed isn't grouped by service
{
  let rng = 1729;
  const rand = () => (rng = (rng * 9301 + 49297) % 233280) / 233280;
  for (let i = built.length - 1; i > 0; i--) {
    const j = Math.floor(rand() * (i + 1));
    [built[i], built[j]] = [built[j], built[i]];
  }
}

export const REVIEWS = built;

export const SERVICE_FILTERS = [
  { key: 'all', label: 'All Services' },
  ...SERVICES.map(({ key, label }) => ({ key, label })),
];

// =====================================================================
// 7. Video testimonials (unchanged)
// =====================================================================
export const VIDEOS = [
  { id: 'vid1', name: 'Ramesh Negi',    city: 'Dehradun', title: 'Termite Problem Solved in 2 Days',         duration: '1:25', thumb: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&q=80',     youtubeId: 'dQw4w9WgXcQ' },
  { id: 'vid2', name: 'Ananya Sharma',  city: 'Rishikesh', title: 'Cockroach-Free Kitchen After EntoRid',     duration: '0:58', thumb: 'https://images.unsplash.com/photo-1604187350919-3c8a2d0d5a5d?w=600&q=80',     youtubeId: 'dQw4w9WgXcQ' },
  { id: 'vid3', name: 'Vikas Bisht',    city: 'Haridwar', title: 'Pre-Construction Termite Treatment Review', duration: '2:10', thumb: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=600&q=80',     youtubeId: 'dQw4w9WgXcQ' },
  { id: 'vid4', name: 'Priyanka Rawat', city: 'Haldwani', title: 'Safe Treatment with Kids & Pets at Home',   duration: '1:42', thumb: 'https://images.unsplash.com/photo-1583337130417-3346a1be7dee?w=600&q=80',     youtubeId: 'dQw4w9WgXcQ' },
  { id: 'vid5', name: 'Sandeep Panwar', city: 'Roorkee',  title: 'Rodent Infestation Completely Cleared',     duration: '1:15', thumb: 'https://images.unsplash.com/photo-1585159812596-fac104f2f069?w=600&q=80',     youtubeId: 'dQw4w9WgXcQ' },
  { id: 'vid6', name: 'Meera Joshi',    city: 'Mussoorie', title: 'Monsoon Mosquito Fogging Experience',      duration: '2:30', thumb: 'https://images.unsplash.com/photo-1599843347624-f956f92d0b1c?w=600&q=80',     youtubeId: 'dQw4w9WgXcQ' },
  { id: 'vid7', name: 'Amit Nautiyal',  city: 'Nainital',  title: 'Annual Maintenance Plan Review',           duration: '1:55', thumb: 'https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?w=600&q=80',     youtubeId: 'dQw4w9WgXcQ' },
  { id: 'vid8', name: 'Neha Gusain',    city: 'Rudrapur',  title: 'Why Our Restaurant Chose EntoRid',         duration: '3:05', thumb: 'https://images.unsplash.com/photo-1559526324-4b87b5e36e44?w=600&q=80',     youtubeId: 'dQw4w9WgXcQ' },
];

// =====================================================================
// 8. Overall stats — used on the hero
// =====================================================================
const FIVE = REVIEWS.filter(r => r.rating === 5).length;
const FOUR = REVIEWS.filter(r => r.rating === 4).length;
const AVG = ((FIVE * 5 + FOUR * 4) / (FIVE + FOUR)).toFixed(2); // ~4.97

export const REVIEW_STATS = {
  averageRating: Number(AVG),
  totalCustomers: '2,867+',
  total: FIVE + FOUR,                 // 2867
  fiveStar: FIVE,                     // 2787
  fourStar: FOUR,                     // 80
  verified: true,
};
